const defaultState = {
  gifts: { isFetched: false, gifts: [] },
  submitData: {},
  error: ''
};

export default function rex(state = defaultState, action) {
  switch (action.type) {
    case 'REX_FETCHING':
      return { ...defaultState };

    case 'REX_GIFTS': {
      const gifts = action.gifts ? [...action.gifts] : [];
      return {...state, gifts: { gifts, isFetched: true }};
    }

    case 'REX_RESET':
      return { ...defaultState };

    case 'REX_ERROR':
      return { ...state, error: action.error, gifts: { gifts: [], isFetched: true } };

    case 'REX_RESET_ERRORS':
      return { ...state, error: '' };

    case 'REX_SUBMIT':
      return { ...state, submitData: { ...action.data } };

    case 'REX_SUBMIT_ERROR':
      return { ...state, error: action.error };
  }

  return state;
}



// WEBPACK FOOTER //
// ./web/js/stores/reducers/rex.js